module.exports = __webpack_public_path__ + "img/pnut_tokencreate.93c4f52.png";